import { API_ENDPOINT } from "../constants";
import { useCallback } from "react";
import { useRefetchBlendedInApp } from "./useRefetchBlendedInApp";

export interface IUseGetSubscription {
  subscriptionId: string;
  subscriptionConfigurationToken: string;
}

export const useRemoveChannel = (input: IUseGetSubscription) => {
  const { refetchBlendedInApp } = useRefetchBlendedInApp();
  const removeChannel = useCallback(
    async (id: string) => {
      await fetch(
        `${API_ENDPOINT}/api/subscriptions/${input.subscriptionId}/channels/${id}?source=blended_installable`,
        {
          method: "DELETE",
          headers: {
            "x-vestaboard-subscription-configuration-token":
              input.subscriptionConfigurationToken,
            "content-type": "application/json",
          },
        }
      ).then((res) => res.json());
      await refetchBlendedInApp();
    },
    [
      input.subscriptionConfigurationToken,
      input.subscriptionId,
      refetchBlendedInApp,
    ]
  );

  return removeChannel;
};
